import { pmHistoryPluginKey } from '@atlaskit/editor-common/utils';
export var getPmHistoryPlugin = function getPmHistoryPlugin(state) {
  return state.plugins.find(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (plugin) {
    return plugin.key === pmHistoryPluginKey;
  });
};
export var getPmHistoryPluginState = function getPmHistoryPluginState(state) {
  var pmHistoryPlugin = getPmHistoryPlugin(state);
  if (!pmHistoryPlugin) {
    return;
  }
  return pmHistoryPlugin.getState(state);
};